// src/utils/math.tsx
function remainder(n, d) {
  return (n % d + Math.abs(d)) % d;
}
export {
  remainder
};
//# sourceMappingURL=math.js.map